import { useAppSelector } from '@/redux/hooks'
import { TranslateIcon } from '@/ui/icons/translate'
import { Select, SelectItem } from '@heroui/react'
import { useTranslation } from 'react-i18next'

const languages = [
    { key: 'en', label: 'English' },
    { key: 'es', label: 'Español' },
    { key: 'fr', label: 'Français' },
    { key: 'de', label: 'Deutsch' },
    { key: 'it', label: 'Italiano' },
    { key: 'pt', label: 'Português' }
] as const

const hoffLanguages = languages.filter(
    (language) => language.key === 'en' || language.key === 'es'
)

export const LanguageSelect = () => {
    const { i18n, t } = useTranslation()

    const handleLanguageChange = (lang: string) => {
        i18n.changeLanguage(lang)
        localStorage.setItem('userPreferredLang', lang)
    }
    const group = useAppSelector(
        (store) => store.settingsApi.settings.response.ecommerce_group
    )
    const isHoff = group === 'hoff'

    if (isHoff) {
        return (
            <Select
                radius="sm"
                size="sm"
                selectedKeys={[i18n.language]}
                aria-label={t('login.select_language')}
                onChange={(e) => handleLanguageChange(e.target.value)}
                className="w-24 bg-transparent font-haas text-neutral-500"
                classNames={{
                    trigger:
                        'bg-transparent font-haas text-xs hover:bg-transparent shadow-none data-[hover=true]:bg-transparent',
                    listbox: 'rounded-sm font-haas text-xs',
                    popoverContent: 'text-neutral-500 bg-white rounded-md'
                }}
            >
                {hoffLanguages.map((language) => (
                    <SelectItem
                        key={language.key}
                        classNames={{
                            base: 'w-36 text-xs text-neutral-500 font-haas data-[selectable=true]:focus:outline-none data-[selectable=true]:font-semibold data-[selectable=true]:focus:bg-white'
                        }}
                    >
                        {language.label}
                    </SelectItem>
                ))}
            </Select>
        )
    }

    return (
        <Select
            radius="sm"
            size="sm"
            selectedKeys={[i18n.language]}
            aria-label={t('login.select_language')}
            onChange={(e) => handleLanguageChange(e.target.value)}
            startContent={<TranslateIcon className="size-5 text-neutral-500" />}
        >
            {languages.map((language) => (
                <SelectItem
                    key={language.key}
                    classNames={{
                        base: 'data-[selectable=true]:focus:outline-none data-[selectable=true]:focus:bg-neutral-100'
                    }}
                >
                    {language.label}
                </SelectItem>
            ))}
        </Select>
    )
}
